import React, { useEffect, useState } from 'react';

import { getNumberOfColumns } from './modal-printer-comparison.utils';
import ModalPrinterComparisonTable from './modal-printer-comparison-table';
import { ModalPrinterComparisonProps } from './types';
import { Container, ModalContainer, ScrollbarWrapper, Title } from './styles';
import { ThemeProvider } from 'styled-components';
import { useScreenSize } from '../../hooks/useScreenSize';

const ModalPrinterComparison: React.FC<ModalPrinterComparisonProps> = ({
  isOpen,
  setOpenModal,
  initialSelection,
  labels,
  productsInfo,
  productsOptions,
  featuresData,
  printersPriority,
  onAnalytics,
}) => {
  const [columnNumber, setColumnNumber] = useState(
    getNumberOfColumns(productsOptions)
  );
  const { isMobile } = useScreenSize();

  useEffect(() => {
    const resizeHandler = () => {
      const columnNumber = getNumberOfColumns(productsOptions);
      setColumnNumber(columnNumber);
    };
    resizeHandler();
    window.addEventListener('resize', resizeHandler);
    return () => window.removeEventListener('resize', resizeHandler);
  }, []);

  return (
    <ThemeProvider
      theme={{
        mb: isMobile,
      }}
    >
      <ModalContainer
        show={isOpen}
        maxWidth={'1064px'}
        closeButton
        onClose={() => setOpenModal(false)}
        data-testid="ModalPrinterComparisonVisid"
      >
        <Container>
          <Title className="title-small">{labels.title}</Title>
          <ScrollbarWrapper>
            <ModalPrinterComparisonTable
              initialSelection={initialSelection}
              columnsNumber={columnNumber}
              fullSpecsLabel={labels.fullSpecs}
              productsInfo={productsInfo}
              productsOptions={productsOptions}
              featuresData={featuresData}
              printersPriority={printersPriority}
              onAnalytics={onAnalytics}
            />
          </ScrollbarWrapper>
        </Container>
      </ModalContainer>
    </ThemeProvider>
  );
};

export default ModalPrinterComparison;
